module.exports = __webpack_public_path__ + "static/media/iconExclamationMark.904c5f12.svg";